var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"keep"}},[_c('GrPublicNavBarEvent'),_vm._v(" "),_c('v-main',[_c('v-sheet',{attrs:{"height":"100%"}},[_c('nuxt')],1)],1),_vm._v(" "),_c('IsOnIEModal',{ref:"IsOnIEModal"}),_vm._v(" "),_c('SuccessErrorSnackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }